import React from 'react'

type Props = {
  address: {
    street?: string
    city?: string
    zip?: string
    country?: string
  }
}

export const FormattedAddress = ({ address }: Props) => {
  return (
    <>
      {address.street && <div>{address.street}</div>}
      {(address.city || address.zip) && (
        <div>
          {address.city} {address.zip}
        </div>
      )}
      {address.country && <div>{address.country}</div>}
    </>
  )
}
